(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('portal-role', {
            parent: 'entity',
            url: '/portal-role',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.portalRole.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-role/portal-roles.html',
                    controller: 'PortalRoleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalRole');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('portal-role-detail', {
            parent: 'portal-role',
            url: '/portal-role/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.portalRole.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-role/portal-role-detail.html',
                    controller: 'PortalRoleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalRole');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PortalRole', function($stateParams, PortalRole) {
                    return PortalRole.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'portal-role',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('portal-role-detail.edit', {
            parent: 'portal-role-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-dialog.html',
                    controller: 'PortalRoleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PortalRole', function(PortalRole) {
                            return PortalRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('portal-role.new', {
            parent: 'portal-role',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-dialog.html',
                    controller: 'PortalRoleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                roleId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('portal-role', null, { reload: 'portal-role' });
                }, function() {
                    $state.go('portal-role');
                });
            }]
        })
        .state('portal-role.edit', {
            parent: 'portal-role',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-dialog.html',
                    controller: 'PortalRoleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PortalRole', function(PortalRole) {
                            return PortalRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('portal-role', null, { reload: 'portal-role' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('portal-role.delete', {
            parent: 'portal-role',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-delete-dialog.html',
                    controller: 'PortalRoleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PortalRole', function(PortalRole) {
                            return PortalRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('portal-role', null, { reload: 'portal-role' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
